module.exports = __webpack_public_path__ + "img/1557614086824468481.440b2c3a.png";